import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import CocinaData from '../../Components/Admin/CocinaData/CocinaData';
import './Cocina.css';

export default function Cocina() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container cocina-container-custom'>
                    <CocinaData />
                </div>
            </section>
        </div>
    );
}

